<div class="modal-header">
  <div class="container-fluid d-print-none">
    <div class="row">
      <div class="col p-0 d-lg-flex align-items-center justify-content-between w-100">
        <a (click)="back()"><i class="fa fa-arrow-left"></i>&nbsp;<span i18n>Back</span></a>
        <h1 class="text-nowrap" i18n>Discard Changes</h1>
      </div>
    </div>
  </div>
</div>

<div class="modal-body p-3">
  <span i18n>There are unsaved changes!</span>
  <br />
  <br />
  <span i18n>Are you sure you want to discard these changes?</span>
</div>

<div class="modal-footer">
  <div class="d-flex mt-3">
    <button type="button" class="btn btn-primary" (click)="onYes()">Yes</button>
    <button type="button" class="btn btn-secondary" (click)="onNo()" #focus>No</button>
  </div>
</div>
